import { BASE_INFO_FIELD_KEY_LIST } from '../../capabilities/base-info/fieldKeys';
import { COMPUTE_FIELD_KEY_LIST } from '../../capabilities/compute/fieldKeys';
import { CONTAINER_STORAGE_FIELD_KEY_LIST } from '../../capabilities/container-storage/fieldKeys';
import { DNS_FIELD_KEY_LIST } from '../../capabilities/dns/fieldKeys';
import { ENV_VARS_FIELD_KEY_LIST } from '../../capabilities/env-vars/fieldKeys';
import { IMAGE_FIELD_KEY_LIST } from '../../capabilities/image/fieldKeys';
import { NETWORK_FIELD_KEY_LIST } from '../../capabilities/network/fieldKeys';
import { RUN_POLICY_FIELD_KEY_LIST } from '../../capabilities/run-policy/fieldKeys';
import { SERVICE_FIELD_KEY_LIST } from '../../capabilities/service/fieldKeys';
import { STARTUP_COMMAND_ARGS_FIELD_KEY_LIST } from '../../capabilities/startup-command-args/fieldKeys';
import { SYSTEM_DISK_SIZE_FIELD_KEY_LIST } from '../../capabilities/system-disk-size/fieldKeys';

export const CI_FIELD_KEYS = [
  ...BASE_INFO_FIELD_KEY_LIST,
  ...NETWORK_FIELD_KEY_LIST,
  ...RUN_POLICY_FIELD_KEY_LIST,
  ...IMAGE_FIELD_KEY_LIST,
  ...SYSTEM_DISK_SIZE_FIELD_KEY_LIST,
  ...STARTUP_COMMAND_ARGS_FIELD_KEY_LIST,
  ...ENV_VARS_FIELD_KEY_LIST,
  ...SERVICE_FIELD_KEY_LIST,
  ...COMPUTE_FIELD_KEY_LIST,
  ...CONTAINER_STORAGE_FIELD_KEY_LIST,
  ...DNS_FIELD_KEY_LIST,
] as const;

export type CiFieldKey = (typeof CI_FIELD_KEYS)[number];
